import React, { useState, useEffect }  from 'react';
import Style from '../styles/pages/AnimationDetailPage.module.scss'
import { Link, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom';
import { useGetAnimationByIdQuery , useUnsubscribeMutation} from '../services/AnimationsAPI';
import Loader from '../components/layout/Loader';
import { RootState } from '../store/GlobalStore';
import calendar from '../shared/images/Icon awesome-calendar-alt.svg';
import pin from '../shared/images/Icon ionic-md-pin.svg';
import people from '../shared/images/Icon material-people.svg';
import { useTranslation } from 'react-i18next';
import arrowLeft from '../shared/images/icon-arrow-left.svg'
import { addNotification } from '../store/slices/notificationSlice';
const AnimationDetailPage: React.FC = () => {
    const { t, i18n  } = useTranslation();
    const { id } = useParams<{ id: string }>();
    const [unsubscribe, { isError, isSuccess }] = useUnsubscribeMutation()
    const {
        data: animationData,
        error: animationError,
        isLoading: animationLoading,
        refetch 
    } = useGetAnimationByIdQuery(Number(id))
    const [nbParticipants, setNbParticipants] = useState<number>(1);
    const authState = useSelector((state: RootState) => state.Auth)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const options : Intl.DateTimeFormatOptions   = { 
        weekday: 'short', // Utiliser "short", "long", ou "narrow"
        year: 'numeric',  // Utiliser "numeric" ou "2-digit"
        month: 'short',   // Utiliser "numeric", "2-digit", "long", "short", ou "narrow"
        day: 'numeric',   // Utiliser "numeric" ou "2-digit"
        hour: '2-digit',  // Utiliser "numeric" ou "2-digit" pour afficher l'heure
        minute: '2-digit'    // Utiliser "numeric" ou "2-digit"
      };

    useEffect(() => {
        refetch(); // <-- Refetch la donnée à chaque chargement ou modification de l'ID
    }, [id, refetch]);

    useEffect(() => {

        if(animationData?.Inscriptions !== undefined && authState?.user !== null)
            for(let i=0; i < animationData?.Inscriptions.length ; i++){
                if(animationData?.Inscriptions[i].user.id === authState?.user.id)
                    setNbParticipants(animationData?.Inscriptions[i].participants)
            }
    }, [animationData]);
    

    if (animationLoading) {
        return <Loader />;
    }

    if (animationError || !animationData) {
        return <div>Error occurred while fetching the animation details.</div>;
    }

    const handleClick = async () => {
        if(id !== undefined && authState?.user?.id !== undefined)
            try {
                
                const result: {data : {message : string, status : string}} = (await unsubscribe({id : Number(id), userId: authState?.user?.id})) as {data : {message : string, status : string}}
                console.log(result)
                if (result.data?.status === 'success') {
                    dispatch(
                        addNotification({
                            message:
                                "Vous vous êtes correctement désinscrit à l'animation : " + animationData.title,
                            type: 'success'
                        })
                    )
                    navigate('/my-animations') // Rediriger l'utilisateur
                }
            } catch (error) {
                console.error('Failed to update user:', error)
            }
      };

      const isFutureDate = new Date(animationData.date) > new Date();

    return (
        <div className={Style.AnimationContainer}>
            <div className={Style.TopContainer}>
                <Link to='/my-animations'>
                    <button className={Style.arrowButton}>
                        <img src={arrowLeft} alt='Arrow Left' />
                    </button>
                </Link>
                <h2>{animationData.title}</h2>
            </div>
            <form className={Style.ModifyLesseeForm}>
                <div className={`${Style.ModifyLesseeFormChild}`}>
                    <div className={Style.DesktopFormField}>
                        <div className={`${Style.InputContainer} ${Style.Resa}`}>
                            <div className={Style.Label}>{t('resa_num')}</div>
                            <div className={Style.DataId} id='id'>{authState?.reservations[0]?.asterioId}</div>
                        </div>
                    </div>
                    <div className={Style.Details}>
                        <Link to={`/reserve-animation/${animationData.id}`}>{t('voir_fiche')}</Link>
                    </div>
                    <div className={Style.DesktopFormField}>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}  id='date'>
                            <img
                                    src={calendar}
                                    alt='calendar'
                                    className={Style.AccountIcon}
                                />
                                {new Date(animationData.date).toLocaleDateString('fr-FR', options).replace(',', ' à')}
                                </div>
                            <div className={Style.Data} id='duration'>{t('duree')} : {animationData.duration}</div>
                        </div>
                    </div>
                    <div className={Style.DesktopFormField}>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}>
                            <img
                                    src={people}
                                    alt='calendar'
                                    className={Style.AccountIcon}
                                />
                                Participant(s)
                                </div>
                            <div className={Style.Data} id='participants'>{nbParticipants} {t('participant')}s</div>
                        </div>
                        <div className={Style.InputContainer}>
                            <div className={Style.Label}>
                            <img
                                    src={pin}
                                    alt='calendar'
                                    className={Style.AccountIcon}
                                />
                                {t('address')}
                                </div>
                            <div className={Style.Data} id='address'>{animationData.address}</div>
                        </div>
                    </div>
                </div>
            </form>
            <div>
            {/* Afficher le bouton uniquement si la date est dans le futur */}
                {isFutureDate && (
                    <button onClick={handleClick} className={Style.Unsubscribe}>
                        {t('unsubscribe')}
                    </button>
                )}
            </div>
        </div>
    );
}

export default AnimationDetailPage
